export default __webpack_public_path__ + "static/media/O-078.c9b5c7eb.png";